import Vue from 'vue'

const getDefaultState = () => {
    return {
        questions: [],
        currentQuestionId: 0,
        values: {
            companyIndustry: '',
            activeRegions: '',
            annualShare: '',
            annualTurnover: ''
        },
        result: 0
    }
}

const annualShareValues = Object.freeze({
    '0-25': 12,
    '25-50': 37,
    '50-75': 62,
    '75-100': 87
})

const annualTurnOverValues = Object.freeze({
    'less-500000': 250000,
    '500000-1000000': 750000,
    '1000000-2000000': 1500000,
    '2000000-5000000': 2500000,
    'more-5000000': 5000000
})

const state = getDefaultState()

// getters
const getters = {
    values: (state) => state.values,
    currentQuestion: (state) => {
        return state.questions ? state.questions[state.currentQuestionId] : null
    },
    allQuestions: (state) => {
        return state.questions
    },
    result: (state) => {
        let annualShare = annualShareValues[state.values.annualShare]
        const annualTurnover = annualTurnOverValues[state.values.annualTurnover]
        annualShare = parseInt(annualShare) === 25 ? 1 : annualShare
        state.result = Math.ceil((annualShare / 100) * (annualTurnover) * (4 / 100))
        return state.result
    },
    text: (state) => {
        if (state.result <= 5000) {
            return { resultText: '<5k', image: 'icon-result-lt-5k' }
        } else if (state.result > 5000 && state.result < 10000) {
            return { resultText: '>5k & <10k', image: 'icon-result-lt-5k' }
        } else if (state.result >= 10000 && state.result < 20000) {
            return { resultText: '10k-20k', image: 'icon-result-10-20' }
        } else if (state.result >= 20000 && state.result < 50000) {
            return { resultText: '20k-50k', image: 'icon-result-20-50' }
        } else {
            return { resultText: '>50k', image: 'icon-result-gt-50' }
        }
    }
}

// mutations
const mutations = {
    setQuestion: (state) => {
        let questions = []
        questions = require('../../resources/ch/questionMap.json')
        state.questions = questions.questions || null
    },
    nextQuestion: (state) => {
        if (state.values[state.questions[state.currentQuestionId].name]) {
            state.currentQuestionId += 1
            if (state.currentQuestionId < state.questions.length) {
                state.questions[state.currentQuestionId].show = true
            }
        }
    },
    setCurrentChoice: (state, choice) => {
        state.values[choice.name] = choice.value
    },
    goBackToQuestion: (state, questionIndex) => {
        state.currentQuestionId = questionIndex
        Object.keys(state.values).forEach((key, index) => {
            if (index > questionIndex) {
                state.values[key] = ''
                state.questions[index].show = false
                Vue.set(state.questions, index, state.questions[index])
            }
        })
    }
}

// actions
const actions = {
    setQuestion: ({ commit }) => {
        commit('setQuestion')
    },
    nextQuestion: ({ commit }) => {
        commit('nextQuestion')
    },
    setCurrentChoice: ({ commit }, choice) => {
        commit('setCurrentChoice', choice)
    },
    goBackToQuestion: ({ commit }, questionIndex) => {
        commit('goBackToQuestion', questionIndex)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
